import axios from '@/utilities/api/axios';

export const state = initialState();

export const actions = {
  getTemplateFields: async ({ commit }) => {
    const res = await axios.get(`/template-fields`);

    commit('mutateTemplateFields', res.data);
  },

  getTemplateKinds: async ({ commit }) => {
    try {
      const res = await axios.get(`/kinds`);

      commit('mutateTemplateKinds', res.data);
      return res.status;
    } catch (err) {
      console.error(err);
      return;
    }
  }
};

export const mutations = {
  mutateTemplateFields: (state, payload) => {
    state.templateFields = payload;
  },

  mutateTemplateKinds: (state, payload) => {
    state.templateKinds = payload;
  }
};

export const getters = {};

function initialState() {
  return {
    templateFields: [],
    templateKinds: []
  };
}
